<div class="container"  *ngIf="!isError">
  <div class="wrapper">
    <div class="title-container">
      <ion-text class="title ion-text-start"> Confirma los datos </ion-text>
      <ion-text class="label ion-text-start">
        Revisa y confirma los datos para tu Congelamiento de saldos</ion-text
      >
    </div>

    <div class="grid-section" *ngIf="isAnyObligatoryAccountWithSelectedFunds()">
      <div class="table-title-section">
        <ion-text class="table-title">Cuentas Obligatorias</ion-text>
      </div>
      <div class="grid-container">
        <ion-grid class="grid">
          <ion-row class="grid-header">
            <ion-col class="left-header-col" size="6">
              <ion-text class="selected-amount-text"> Cuenta </ion-text></ion-col
            >
            <ion-col class="right-header-col">
              <ion-text class="selected-amount-text"> Saldo a congelar </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-total" *ngIf="ccoSelectedAmount">
            <ion-col class="left-col" size="7">
              <ion-text class="account-type-text"> Ahorro Obligatorio </ion-text></ion-col
            >
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ numberToChileanCurrency(ccoSelectedAmount) }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-total" *ngIf="cdcSelectedAmount">
            <ion-col class="left-col" size="7">
              <ion-text class="account-type-text">Depósito Convenido</ion-text></ion-col
            >
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ numberToChileanCurrency(cdcSelectedAmount) }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-total">
            <ion-col class="left-col" size="7">
              <ion-text class="selected-amount-text"> Total a congelar </ion-text></ion-col
            >
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ getTotalObligatorySelectedFunds() }}
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>

    <div class="grid-section" *ngIf="isAnyVoluntaryAccountWithSelectedFunds()">
      <div class="table-title-section">
        <ion-text class="table-title"> Cuentas Voluntarias </ion-text>
      </div>
      <div class="grid-container">
        <ion-grid class="grid">
          <ion-row class="grid-header">
            <ion-col class="left-header-col" size="6">
              <ion-text class="selected-amount-text"> Cuenta </ion-text></ion-col>
            <ion-col class="right-header-col">
              <ion-text class="selected-amount-text"> Saldo a congelar </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-voluntary-account" *ngIf="ccvSelectedAmount">
            <ion-col class="left-col" size="7">
              <ion-text class="account-type-text">
                APV - Ahorro Previsional Voluntario <br/></ion-text>
              <ion-text class="account-type-text">
                Saldo: {{ numberToChileanCurrency(ccvAmount) }}
              </ion-text>
            </ion-col>
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ numberToChileanCurrency(ccvSelectedAmount) }}
              </ion-text>
              <ion-text class="selected-percentage-text">
                {{ ccvSelectedPercentage }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-voluntary-account" *ngIf="cavSelectedAmount">
            <ion-col class="left-col" size="7">
              <ion-text class="account-type-text">Cuenta 2 - Ahorro Voluntario<br /></ion-text>
              <ion-text class="account-type-text">
                Saldo: {{ numberToChileanCurrency(cavAmount) }}</ion-text
              >
            </ion-col>
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ numberToChileanCurrency(cavSelectedAmount) }}
              </ion-text>
              <ion-text class="selected-percentage-text">
                {{ cavSelectedPercentage }}
              </ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="grid-content-total">
            <ion-col class="left-col" size="7">
              <ion-text class="selected-amount-text"> Total a congelar </ion-text></ion-col
            >
            <ion-col class="right-col">
              <ion-text class="selected-amount-text">
                {{ getTotalVoluntarySelectedFunds() }}</ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
    <div
      class="grid-section"
      *ngIf="isAnyObligatoryAccountWithSelectedFunds()
      && isAnyVoluntaryAccountWithSelectedFunds()">
      <div class="grid-container">
        <ion-grid class="grid">
          <ion-row class="grid-content-total">
            <ion-col class="left-col" size="7">
              <ion-text class="selected-amount-text"> Saldo total a congelar </ion-text></ion-col>
            <ion-col class="right-col">
              <ion-text class="selected-amount-text"> {{ getTotalSelectedFunds() }} </ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>

    <div class="condition-box">
      <div class="checkbox">
        <ion-checkbox
          [(ngModel)]="acceptedTerms"
          slot="start"
          (click)="!acceptedTerms && openTermsAndConditionsModal()"
          (keydown.enter)="!acceptedTerms && openTermsAndConditionsModal()"
        >
        </ion-checkbox>
        <h3>
          He leído y acepto los
          <a class="terminos" (click)="openTermsAndConditionsModal()">términos y condiciones</a>
          del Congelamiento de saldos
        </h3>
      </div>
    </div>

    <div class="action-container">
      <button class="b-btn s-button" (click)="exit()">Salir</button>
      <button class="b-btn p-button" [disabled]="!acceptedTerms || loading" (click)="continue()">
        Continuar
        <ion-spinner
          name="crescent"
          slot="end"
          *ngIf="loading; else noLoading"
          color="light"
        ></ion-spinner>
        <ng-template #noLoading>
          <ion-icon name="arrow-forward-outline"></ion-icon>
        </ng-template>
      </button>
    </div>
  </div>
</div>
<app-generic-error 
*ngIf="isError"
[ops]="errorOps" 
[retryAttempt]="attempt" 
(retryEvent)="onRetryEvent()"
(goToEvent)="onGoToEvent()"
[enableWhatsapp]="false">
</app-generic-error>